import React from "react";
import Axios from 'axios'
import Cartela from '../_Components/Cartela'
import API from '../Utils/api'
import { Link } from 'react-router-dom';

export class CartelasAtuais extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pedidos: [],
            lotes: [],
            series: [],
            cartelasDePedidos: [],
            cartelasDeLotes: [],
            cartelasDeSeries: [],
            todasAsCartelas: []
        };
        this.getTodosPedidos()
        this.getTodosLotes()
        this.getTodasSeries()
    }

    async getTodasSeries() {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("series/", {
            });
            this.setState({ series: response.data })
            if (response.data)
                this.getTodasCartelasSeries()
        } catch (err) {
            console.log(err);
        }
    }

    async getTodosLotes() {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("lotes/all-lotes", {
            });
            this.setState({ lotes: response.data })
            if (response.data)
                this.getTodasCartelasLotes()
        } catch (err) {
            console.log(err);
        }
    }

    async getTodosPedidos() {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("pedidos/listar-2", {});
            this.setState({ pedidos: response.data });
            if (response.data)
                this.getTodasCartelasPedidos()
        } catch (err) {
            console.log(err);
        }
    }

    getTodasCartelasPedidos() {
        var cartelas = []
        this.state.pedidos.map(pedido => {
            pedido.cartelas.map((cartela, index) => {
                cartelas.push({ cartela: cartela, tipo: 'pedido', index: index, pedido: pedido })
            })
        })
        this.setState({ cartelasDePedidos: cartelas })
    }

    getTodasCartelasLotes() {
        var cartelas = []
        this.state.lotes.map(lote => {
            lote.cartelas.map((cartela, index) => {
                cartelas.push({ cartela: cartela, tipo: 'lote', index: index, lote: lote })
            })
        })
        this.setState({ cartelasDeLotes: cartelas })
    }

    getTodasCartelasSeries() {
        var cartelas = []
        this.state.series.map(serie => {
            serie.cartelas.map((cartela, index) => {
                cartelas.push({ cartela: cartela, tipo: 'serie', index: index, serie: serie })
            })
        })
        this.setState({ cartelasDeSeries: cartelas })
    }

    concatenaTodas() {
        var elementos = [...this.state.cartelasDePedidos, ...this.state.cartelasDeSeries, ...this.state.cartelasDeLotes];
        var todas = [];
        elementos.map(cartela => {
            todas.push(cartela)
        })

        this.setState({ todasAsCartelas: todas.sort(this.compararCodigo) })
    }


    compararCodigo(a, b) {
        if (a.cartela.codigo > b.cartela.codigo) {
            return 1;
        }
        if (a.cartela.codigo < b.cartela.codigo) {
            return -1;
        }

        return 0
    }


    async modificarPedido(pedido, cartela) {
        pedido.cartelas.map((card,index) => {
            if(cartela.codigo == card.codigo){
                pedido.cartelas.splice(index, 1);
            }
        })

        try {
            const response1 = await API.post("/api/pedidos/adiciona-cartela", {
                id: pedido._id,
                pedido: {cartelas: pedido.cartelas}
            });
       
            if (response1.data) {
                console.log('pedido : ' + pedido.codigo + ' modificado')
            }
        } catch (err) {
            console.log(err);
        }
    }


    async deletarPedido(pedido) {
        try {
            const response1 = await API.post("/api/pedidos/deleta", {
                id: pedido._id
            });
            const response2 = await API.post("/api/transacoes/deleta", {
                id: pedido.transacaoId,
            });

            if (response1.data) {
                console.log('pedido : ' + pedido.codigo + ' deletado')
            }
            if (response2.data) {
                console.log('transacao : ' + pedido.codigo + ' deletado')
            }
        } catch (err) {
            console.log(err);
        }
    }


    comparaAdjadcentes(e) {
        var index = e;
        var lastIndex = index - 1;
        var nextIndex = index + 1;
        var item = this.state.todasAsCartelas[index];
        if (this.state.todasAsCartelas[lastIndex] && this.state.todasAsCartelas[nextIndex] &&
            (this.state.todasAsCartelas[index - 1].cartela.codigo == item.cartela.codigo ||
                this.state.todasAsCartelas[index + 1].cartela.codigo == item.cartela.codigo)) {
            this.state.count++;
            if (this.state.todasAsCartelas[index + 1].cartela.codigo == item.cartela.codigo && item.tipo == 'pedido' && this.state.todasAsCartelas[index + 1].tipo == 'pedido') {
                item.pedido.cartelas.length > 1 ? this.modificarPedido(item.pedido, item.cartela) : this.deletarPedido(item.pedido)
            }
            else if (this.state.todasAsCartelas[index + 1].cartela.codigo == item.cartela.codigo && item.tipo == 'serie' && (this.state.todasAsCartelas[index + 1].tipo == 'pedido' || this.state.todasAsCartelas[index - 1].tipo == 'pedido')) {
                this.retirarDaSerie(item)
            }
            else if (this.state.todasAsCartelas[index + 1].cartela.codigo == item.cartela.codigo && item.tipo == 'lote' && (this.state.todasAsCartelas[index + 1].tipo == 'pedido' || this.state.todasAsCartelas[index - 1].tipo == 'pedido')) {
                this.retirarDoLote(item)
            }
            return true;
        }
        else {
            return false;
        }
    }

    async retirarDaSerie(cartela) {

        cartela.serie.cartelas.map((card, index) => {
            if (card.codigo == cartela.cartela.codigo) {
                cartela.serie.cartelas.splice(index, 1)
            }
        })
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.post("series/atualizar-serie", { _id: cartela.serie._id, cartelas: cartela.serie.cartelas });
        } catch (err) {
            console.log(err);
        }
    }

    async retirarDoLote(cartela) {

        cartela.lote.cartelas.map((card, index) => {
            if (card.codigo == cartela.cartela.codigo) {
                cartela.lote.cartelas.splice(index, 1)
            }
        })
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.post("lotes/atualizar-lote", { _id: cartela.lote._id, cartelas: cartela.lote.cartelas });
        } catch (err) {
            console.log(err);
        }
    }

    render() {
        return (
            <div className="container">
                <div className="col">
                    <button onClick={this.concatenaTodas.bind(this)}>Concatenar Todas</button>
                    <h3> pedidos: {this.state.cartelasDePedidos.length}</h3><br />
                    <h3> lotes: {this.state.cartelasDeLotes.length}</h3><br />
                    <h3> series: {this.state.cartelasDeSeries.length}</h3>
                </div>

                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">Detalhes</th>
                            <th scope="col">tipo</th>
                            <th scope="col">index</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.todasAsCartelas.map((cartela, index) => {
                            if (this.comparaAdjadcentes(index)) {
                                return (<tr>
                                    <td>{'card: ' + cartela.cartela.codigo + ' || ' + 'vendendor: ' + cartela.serie?.cambistaId?.nome + ' || ' + 'gerente: ' + cartela.serie?.gerenteId?.nome}</td>
                                    <td>{cartela.tipo == 'pedido' ? cartela.tipo + ': ' + cartela.pedido.codigo : cartela.tipo}</td>
                                    <td>{cartela.index}</td>
                                    <td><button onClick={() => {cartela.tipo == 'serie' ? this.retirarDaSerie(cartela) : this.retirarDoLote(cartela)}}>RETIRAR</button></td>
                                </tr>
                                )
                            }
                        })}

                    </tbody>
                </table>

            </div>
        );
    }


}






export default CartelasAtuais;
